import React from 'react';
import styled from 'styled-components';

import Container from 'components/Container';
import Row from 'components/Row';
import Stack from 'components/Stack';
import Starfield from 'components/Starfield';
import Link from 'components/Link';
import Text from 'components/Text';
import TalkToUsCTA from 'components/TalkToUsCTA';

import IconCalendarCheck from 'images/icons/calendar-check.svg?svgr';
import IconGrowthChart from 'images/icons/growth-chart.svg?svgr';
import IconNetwork from 'images/icons/network.svg?svgr';

import { color } from 'styles/utils';

const Section = styled.section`
  color: ${color('white')};
  padding: 6rem 0 12rem;
  pointer-events: none;
  position: relative;
  text-align: center;
`;

const StyledContainer = styled(Container)`
  padding-inline: 1.5rem;
  pointer-events: auto;
`;

const Propositions = styled(Row)`
  margin-bottom: 1rem;
  max-width: 50rem;
  width: 100%;
`;

const Proposition = styled(Text)`
  align-items: center;
  display: inline-flex;
  gap: 0.75rem;
  text-wrap: nowrap;

  a {
    text-decoration: none;
  }
`;

const StyledHeading = styled(Text)`
  width: 45rem;
  max-width: 100%;
`;

const StyledStarfield = styled(Starfield)`
  top: -9rem;
  mask-image: linear-gradient(#0000 0%, #000 20%, #000 80%, #0000 100%);
`;

export default function EngineeringOnEfficiency() {
  return (
    <Section>
      <StyledStarfield variant="tertiary" />
      <StyledContainer>
        <Stack gap="2rem" align="center">
          <StyledHeading variant="hero">
            You've got the goals, now get the system
          </StyledHeading>

          <Propositions
            align="center"
            breakpoint={null}
            gap="1.5rem"
            layout="auto"
            wrap
          >
            <Proposition variant="smallP">
              <IconCalendarCheck aria-hidden="true" />
              <Link href="/reviews">Reviews</Link>
            </Proposition>
            <Proposition variant="smallP">
              <IconGrowthChart aria-hidden="true" />
              <Link href="/metrics">Metrics</Link>
            </Proposition>
            <Proposition variant="smallP">
              <IconNetwork aria-hidden="true" />
              <Link href="/automations">Automations</Link>
            </Proposition>
          </Propositions>

          <Row colGap="1rem" rowGap="1rem">
            <TalkToUsCTA icon="arrow-up-right" />
          </Row>
        </Stack>
      </StyledContainer>
    </Section>
  );
}
